export default __webpack_public_path__ + "static/media/tour-complete-tick.5ae4bf38.svg";